import { createReducer } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import eventsActions from './eventsActions';

const fetchEvents = (state, action) => {
  const { events, rewrite } = action.payload;
  let arr;
  if (rewrite) {
    arr = [...events];
  } else {
    arr = [...state, ...events];
  }
  const uniqEvents = arr.reduce((acc, el) => {
    return acc.find(i => i.id == el.id) ? acc : [...acc, el];
  }, []);
  return uniqEvents;
};

const fetchSortedEvents = (state, action) => action.payload;

const handleSetRruleEventData = (state, action) => {
  return { ...state, ...action.payload };
};
const editAppointment = (state, action) => {
  const { id, body } = action.payload;
  return [...state.map(event => (Number(event.id) == Number(id) ? { ...event, ...body } : event))];
};
const cancelCanceled = (state, action) => {
  return [...state.map(event => (event.id == action.payload ? { ...event, deleted_date: null } : event))];
};
const setLastRequestDates = (state, action) => action.payload;

const setAllWorkersEvents = (state, action) => action.payload;

const doPayment = (state, action) =>
  state.map(item => (item.id == action.payload ? { ...item, prepayment: item.total_price } : item));

const events = createReducer([], {
  [eventsActions.fetchEventsSuccess]: fetchEvents,
  [eventsActions.editAppointment]: editAppointment,
  [eventsActions.fetchPaymentSuccess]: doPayment,
});

const allWorkersEvents = createReducer([], {
  [eventsActions.fetchAllWorkersEventsSuccess]: setAllWorkersEvents,
});

const sortedEvents = createReducer([], {
  [eventsActions.fetchSortedEventsSuccess]: fetchSortedEvents,
  [eventsActions.cancelCanceledSuccess]: cancelCanceled,
  [eventsActions.fetchPaymentSuccess]: doPayment,
  [eventsActions.clearSortedEvents]: () => [],
});

const cancelLoader = createReducer(false, {
  [eventsActions.cancelCanceledRequest]: () => true,
  [eventsActions.cancelCanceledSuccess]: () => false,
});

const lastDates = createReducer(
  {},
  {
    [eventsActions.setLastRequestDates]: setLastRequestDates,
    [eventsActions.clearLastRequestDates]: () => ({}),
  },
);

const loader = createReducer(false, {
  [eventsActions.fetchEventsSuccess]: () => false,
  [eventsActions.showFetchEventsLoader]: () => true,
  [eventsActions.hideFetchEventsLoader]: () => false,
  [eventsActions.fetchSortedEventsRequest]: () => true,
  [eventsActions.fetchSortedEventsSuccess]: () => false,
  [eventsActions.fetchAllWorkersEventsRequest]: () => true,
  [eventsActions.fetchAllWorkersEventsSuccess]: () => false,
});

const rewriteEvents = createReducer(false, {
  [eventsActions.rewriteEventsStart]: () => true,
  [eventsActions.rewriteEventsEnd]: () => false,
});

const deleteLoader = createReducer(false, {
  [eventsActions.deleteEventRequest]: () => true,
  [eventsActions.deleteEventSuccess]: () => false,
});

const deleteToast = createReducer(false, {
  [eventsActions.showDeleteEventToast]: () => true,
  [eventsActions.hideDeleteEventToast]: () => false,
});

const paymentToast = createReducer(false, {
  [eventsActions.showPaymentToast]: () => true,
  [eventsActions.hidePaymentToast]: () => false,
  [eventsActions.showMultiPaymentToast]: () => true,
  [eventsActions.hideMultiPaymentToast]: () => false,
});

const payLoader = createReducer(false, {
  [eventsActions.fetchPaymentRequest]: () => true,
  [eventsActions.fetchPaymentSuccess]: () => false,
  [eventsActions.fetchMultiPaymentRequest]: () => true,
  [eventsActions.fetchMultiPaymentSuccess]: () => false,
});

const successfulToast = createReducer(false, {
  [eventsActions.showSuccessfulToast]: () => true,
  [eventsActions.hideSuccessfulToast]: () => false,
});

const rruleSheet = createReducer(false, {
  [eventsActions.showRruleSheet]: () => true,
  [eventsActions.hideRruleSheet]: () => false,
});

const changeEventLoader = createReducer(false, {
  [eventsActions.changeEventRequest]: () => true,
  [eventsActions.changeEventSuccess]: () => false,
  [eventsActions.changeEventStartLoader]: () => true,
  [eventsActions.changeEventStopLoader]: () => false,
});

const rruleEventData = createReducer(
  {},
  {
    [eventsActions.setRruleEventData]: handleSetRruleEventData,
    [eventsActions.clearRruleEventData]: () => ({}),
  },
);

const changeEventUndoToast = createReducer(false, {
  [eventsActions.changeEventShowUndoToast]: () => true,
  [eventsActions.changeEventHideUndoToast]: () => false,
});

export default combineReducers({
  changeEventUndoToast,
  successfulToast,
  sortedEvents,
  deleteLoader,
  deleteToast,
  paymentToast,
  rewriteEvents,
  lastDates,
  payLoader,
  events,
  loader,
  cancelLoader,
  rruleSheet,
  rruleEventData,
  changeEventLoader,
  allWorkersEvents,
});
